;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import createProfilePic from "./images/create-profile.jpg"
import fillPic from "./images/fill.jpg"
import postGroupPic from "./images/post-group.jpg"
import runRepeatPic from "./images/run-and-repeat.jpg"

export const TAPE_LINE_ITEMS = [
  {
    pictureSrc: postGroupPic,
    lineNumber: "1.",
    title: "Post group",
    description:
      "Explain & share your group. You decide why, when, and how it meets: such as virtual or in-person.",
  },
  {
    pictureSrc: createProfilePic,
    lineNumber: "2.",
    title: "Create profile",
    description:
      "All groups you post link to your profile, so folks can learn more about you to assess fit.",
  },
  {
    pictureSrc: fillPic,
    lineNumber: "3.",
    title: "Fill Cohort",
    description:
      "People browse available dates and reserve their seat. You can require consultations or enable automatic booking.",
  },
  {
    pictureSrc: runRepeatPic,
    lineNumber: "4.",
    title: "Run & repeat",
    description:
      "Easily manage your group’s operations. Organize plans and reflections, track attendance, get paid, and add additional cohorts!",
  },
]
